'use strict';

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; desc = parent = getter = undefined; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _ = require('../mindash');
var StateSource = require('../core/stateSource');
var locationFactory = defaultLocationFactory;

var LocationStateSource = (function (_StateSource) {
  _inherits(LocationStateSource, _StateSource);

  function LocationStateSource(options) {
    _classCallCheck(this, LocationStateSource);

    _get(Object.getPrototypeOf(LocationStateSource.prototype), 'constructor', this).call(this, options);
    this._isLocationStateSource = true;
  }

  _createClass(LocationStateSource, [{
    key: 'getLocation',
    value: function getLocation(location) {
      return locationFactory(this.app, location);
    }
  }], [{
    key: 'setLocationFactory',
    value: function setLocationFactory(value) {
      locationFactory = value;
    }
  }]);

  return LocationStateSource;
})(StateSource);

module.exports = LocationStateSource;

function defaultLocationFactory(app, location) {
  var l = location || window.location;

  return {
    url: l.url,
    path: l.pathname,
    hostname: l.hostname,
    query: query(l.search),
    protocol: l.protocol.replace(':', '')
  };

  function query(search) {
    var result = {};

    _.each(search.substr(1).split('&'), function (part) {
      var item = part.split('=');
      result[item[0]] = decodeURIComponent(item[1]);
    });

    return result;
  }
}


/*****************
 ** WEBPACK FOOTER
 ** ./~/marty-lib/modules/location-state-source/location.js
 ** module id = 576
 ** module chunks = 0
 **/